import { useFormikInsuranceFormPetName } from '~/hooks/useFormikInsuranceFormPetName';

import { formatPetNameForDisplay } from '~/helpers/pet/petName';

export function useFormikInsuranceFormDisplayFormatPetName(): string {
  const inputPetName = useFormikInsuranceFormPetName();

  return formatPetNameForDisplay(inputPetName);
}
